import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import dashboardReducer from "./slices/dashboardSlice";
import projectReducer from "./slices/projectSlice";
import kanbanReducer from "./slices/kanbanSlice";
import profileReducer from "./slices/profileSlice";
import onboardingReducer from "./slices/onboardingSlice";
import settingsReducer from "./slices/settingsSlice";
import reportsReducer from "./slices/reportsSlice"; 
import leaveReportReducer from "./slices/leavereportslice";
import projectReportReducer from "./slices/projectreportslice";
import myAssetsReducer from "./slices/myAssetsslice";
import organisationReducer from "./slices/organisationSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboard: dashboardReducer,
    project: projectReducer,
    kanban: kanbanReducer,
    profile: profileReducer,
    onboarding: onboardingReducer,
     reports: reportsReducer,
    settings: settingsReducer,
    leaveReport: leaveReportReducer,
    projectReport: projectReportReducer,
    myAssets: myAssetsReducer,
    organisation: organisationReducer,
  },
});

export default store;
